import { apiSlice } from 'api/apiSlice'
import { Address, AddressType } from 'shared/types/Address'

const SHIPPING_ADDRESS_COUNT = 5

type GetAddresses = {
  addresses: Address[]
}

const addressesApi = apiSlice.injectEndpoints({
  endpoints: build => ({
    createAddress: build.mutation({
      invalidatesTags: ['Address'],
      query: body => ({
        app: 'sneakers',
        data: body,
        method: 'POST',
        url: '/web-api/v1/addresses',
      }),
    }),
    getAddress: build.query({
      query: addressId => ({
        app: 'sneakers',
        cache: false,
        method: 'GET',
        url: `/web-api/v1/addresses/${addressId}?timestamp=${new Date().getTime()}`,
      }),
    }),
    getAddresses: build.query<GetAddresses, AddressType>({
      providesTags: ['Address'],
      query: () => ({
        app: 'sneakers',
        cache: false,
        method: 'GET',
        url: `/web-api/v1/addresses?timestamp=${new Date().getTime()}`,
      }),
      transformResponse: (response: GetAddresses, _, addressType?: AddressType) => {
        if (addressType) {
          const addresses = response?.addresses || []
          const addressesByType = addresses
            .filter(address => address?.addressType === addressType)
            .slice(0, SHIPPING_ADDRESS_COUNT)
          return { addresses: addressesByType }
        }
        return response
      },
    }),
  }),
})

export const { useCreateAddressMutation, useGetAddressQuery, useGetAddressesQuery } = addressesApi
